import * as React from 'react';
import styled from 'styled-components';
import DownloadImage from '../../assets/ic-download.png';
import {mobileMediaQuery, notWebMediaQuery} from '../../styles';
import ActivityTag from './ActivityTag';

const ActivityGridItem = ({activity, width}) => {
    return (
        <Container backgroundColor={activity.color}>
            <ColorBackground
                backgroundColor={activity.color}
                height={width / 1.8}
            >
                <CharImage src={activity.charImage} height={width / 1.5} />
            </ColorBackground>
            <TextContainer>
                <TextTitle>{activity.title}</TextTitle>
                <HStack>
                    <ActivityTag activity={activity} />
                    <WrappedLink href={activity.file} target="_blank" download>
                        <RoundContainer />
                    </WrappedLink>
                </HStack>
            </TextContainer>
        </Container>
    );
};

const Container = styled.div`
    background-color: transparent;
    position: relative;
    border-radius: 12px;
    overflow: hidden;
    align-items: center;
`;

const CharImage = styled.img`
    width: 328px;
    height: 238px;
    position: absolute;
    left: 0;
    right: 0px;
    bottom: 0px;
    margin-left: auto;
    margin-right: auto;
    max-width: 100%;

    ${notWebMediaQuery} {
        object-fit: contain;
        width: 100%;
        height: ${props => props.height}px;
    }
`;

const TextContainer = styled.div`
    flex: 1;
    background-color: white;
    padding-top: 20px;
`;

const TextTitle = styled.div`
    font-family: 'Oduda';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    text-transform: uppercase;
    color: black;
    height: 44px;
    overflow: hidden;
    margin-block: 0px;
    margin: 0px 28px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;

    ${mobileMediaQuery} {
        font-size: 12px;
        line-height: 14px;
        height: 28px;
        margin: 0px 13px;
    }
`;

const ColorBackground = styled.div`
    position: relative;
    background-color: ${props => props.backgroundColor};
    width: 100%;
    margin-top: 54px;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    height: ${props => props.height}px;
`;

const RoundContainer = styled.div`
    width: 40px;
    height: 40px;
    background: url(${DownloadImage}) no-repeat center;
    background-color: #3577f4;
    border-radius: 50%;

    ${mobileMediaQuery} {
        width: 28px;
        height: 28px;
        background-size: 14px 14px;
    }
`;

const HStack = styled.div`
    flex: 1;
    flex-direction: row;
    display: flex;
    flex-shrink: 1;
    padding: 4px 13px 18px 28px;
    justify-content: space-between;

    ${mobileMediaQuery} {
        padding: 4px 13px 18px 13px;
    }
`;

const WrappedLink = styled.a``;

export default ActivityGridItem;
